<template>
  <b-modal :id="id" size="xl" title="Edit Credit Group" @show="resetModal" @hidden="resetModal" @ok="handleOk">
    <b-table
      stacked
      class="align-middle"
      :borderless="true"
      :fields="[
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'credits',
            label: 'Assigned Credits'
          },
        ]"
      :items="[{
        name,
        credits
      }]"
    >
      <template v-slot:cell(name)>
        <b-form-input v-model="name"></b-form-input>
      </template>
      <template v-slot:cell(credits)>
        <b-form-input v-model="credits" @keypress="filterNumberOnlyWithMax($event)"></b-form-input>
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button
        size="sm"
        :disabled="!isFormValid ? `disabled` : null "
        variant="primary"
        class="bg-site-primary"
        @click="ok()"
      >Update Credit Group</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `CreditGroupEditModal`,
  components: {
  },
  data() {
    return {
      name: null,
      credits: 0,
    };
  },
  props: {
    id: String,
    creditGroup : Object,
  },
  computed: {
    isFormValid() {
      const isNameValid = this.name != null && this.name.length > 0
      const isCreditsValid = !isNaN(this.credits) && this.credits > 0
      return isNameValid && isCreditsValid
    }
  },
  watch: {
    creditGroup(newValue) {
      this.name = newValue ? newValue.name : ''
      this.credits = newValue ? newValue.credits : 0
    }
  },
  methods: {
    filterNumberOnlyWithMax(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (isNaN(this.newExaminees) || this.newExaminees < 0) {
          this.newExaminees = 0;
        }
        return true;
      }
    },
    resetModal(){
      if(this.creditGroup){
        this.name = this.creditGroup.name
        this.credits = this.creditGroup.credits
      }
    },
    handleOk() {
      // Check if Values are complete
      if (!this.isFormValid) {
        return false;
      } 
      else {
        const id = this.creditGroup.id,
          name = this.name, 
          credits = this.credits
        this.$store
          .dispatch(`creditGroup/update`, { id, data : { credits, name}})
          .then(() => {
            this.$emit("ok");
          });
      }
    }
  }
};
</script>
<style scoped>
</style>